import { useQuery } from '@tanstack/react-query';

import { apiClient } from '../../api/ApiClient';

export function useGetBillingLink(returnUrl: string) {
  return useQuery(['getBillingLink'], () => apiClient.getBillingLink({ return_url: returnUrl }), {
    refetchOnWindowFocus: false,
    enabled: false, // turned off by default, manual refetch is needed
  });
}
